import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import AerosDialog from "../AerosDialog";
import useAerosModalStyles from "../../styles/aerosModalStyles";

const selectMenuProps = {
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  getContentAnchorEl: null,
};

const FlowBuilderTagModal = ({ open, onSave, data, onUpdate, close }) => {
  const m = useAerosModalStyles();
  const [activeModal, setActiveModal] = useState(false);
  const [tags, setTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState();

  useEffect(() => {
    if (open === "edit") {
      (async () => {
        try {
          const tag = data.data.tag;
          const { data: result } = await api.get("/tags/list");
          setSelectedTag(tag.id);
          setTags(result);
          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    } else if (open === "create") {
      (async () => {
        try {
          const { data } = await api.get("/tags/list");
          setSelectedTag("");
          setTags(data);
          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    }
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = () => {
    if (!selectedTag) {
      return toast.error(i18n.t("aeros.flow.modals.tag.error"));
    }
    const tag = tags.find((item) => item.id === selectedTag);
    if (open === "edit") {
      onUpdate({
        ...data,
        data: {
          tag: tag ? tag : "",
        },
      });
    } else if (open === "create") {
      onSave({
        tag: tag ? tag : "",
      });
    }
    handleClose();
  };

  return (
    <AerosDialog
      open={activeModal}
      onClose={handleClose}
      width={480}
      title={i18n.t(open === "edit" ? "aeros.flow.modals.tag.editTitle" : "aeros.flow.modals.tag.addTitle")}
      onSubmit={handleSaveContact}
      submitLabel={i18n.t(open === "edit" ? "aeros.flow.save" : "aeros.flow.add")}
    >
      <div>
        <label className={m.fieldLabel} htmlFor="flow-tag-select">
          {i18n.t("aeros.flow.modals.tag.tag")}
        </label>
        <TextField
          id="flow-tag-select"
          select
          className={m.input}
          variant="outlined"
          value={selectedTag ?? ""}
          onChange={(e) => setSelectedTag(e.target.value)}
          SelectProps={{
            displayEmpty: true,
            MenuProps: selectMenuProps,
            renderValue: (v) => {
              if (v === "") return i18n.t("aeros.flow.modals.tag.placeholder");
              const tag = tags.find((t) => t.id === v);
              return tag ? tag.name : i18n.t("aeros.flow.modals.tag.none");
            },
          }}
        >
          <MenuItem value="">
            <em>{i18n.t("aeros.flow.modals.tag.placeholder")}</em>
          </MenuItem>
          {tags.map((tag) => (
            <MenuItem dense key={tag.id} value={tag.id}>
              {tag.name}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </AerosDialog>
  );
};

export default FlowBuilderTagModal;
